import { Flow, StepAssets } from "@dreambigger/shared/src/types";
import { useCallback, useMemo } from "react";
import { changeStepForward } from "../utils/changeStepForward";

export default function useNextStep(
  assets: StepAssets,
  applicationHelper: any,
  flow: Flow,
  currentSlug?: string
) {
  const nextSlugMatchStepResponse = useMemo(() => {
    if (
      typeof assets.nextSlug === "object" &&
      "matchStepSlug" in assets.nextSlug &&
      assets.nextSlug.matchStepSlug !== currentSlug // matchStepSlug should not be used for navigation on the current step. This guards against retrieving stale data.
    ) {
      return applicationHelper.findResponse(
        flow.id,
        "draft",
        assets.nextSlug.matchStepSlug
      );
    }
  }, [assets, applicationHelper, flow]);

  return useCallback(
    (inputValues: any) => {
      if (nextSlugMatchStepResponse) {
        changeStepForward(assets.nextSlug, nextSlugMatchStepResponse.fields);
        return;
      }
      changeStepForward(assets.nextSlug, inputValues);
    },
    [assets, applicationHelper, flow]
  );
}
